export default __webpack_public_path__ + "static/media/writingIcon.ceab88fe.svg";